import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AssessmentMemberData } from '../../../../../models/assessment-member-data';
import { AssessmentMemberAnswer } from '../../../../../models/assessment-member-answer';
import { QuestionType } from '../../../../../models/question-type';
import { RiskFactorRank } from '../../../../../models/risk-factor-rank';

@Component({
  selector: 'lib-risk-assessment-member-answers-modal',
  templateUrl: './risk-assessment-member-answers-modal.component.html',
  styleUrls: ['./risk-assessment-member-answers-modal.component.scss']
})
export class RiskAssessmentMemberAnswersModalComponent {
  public surveyUserId: string;
  public riskAssessmentMembersData: Array<AssessmentMemberData>;
  public templateAssessmentMemberAnswer: AssessmentMemberAnswer;
  public questionType = QuestionType;

  constructor(public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig) {
    this.riskAssessmentMembersData = this.dynamicDialogConfig?.data?.riskAssessmentMembersData;
    this.templateAssessmentMemberAnswer = this.dynamicDialogConfig?.data?.templateAssessmentMemberAnswer;
    this.surveyUserId = this.dynamicDialogConfig?.data?.surveyUserId;
  }

  close(): void {
    return this.dynamicDialogRef.close();
  }

  getFactorRankName(id: string, factors: Array<RiskFactorRank>): string {
    return factors.find((factor: RiskFactorRank) => factor.id === id)?.name || '';
  }

  noMemberAnswers(): boolean {
    // find at least 1 answer for this question that is not a template and doesn't belong to this user
    const anAnswerForThisQuestion: AssessmentMemberData = this.riskAssessmentMembersData.find((ramd: AssessmentMemberData) => {
      return !ramd.template && ramd.memberData.member.id !== this.surveyUserId && ramd.memberAnswers.find((ma: AssessmentMemberAnswer) => ma.parent.id === this.templateAssessmentMemberAnswer.id);
    });
    return !anAnswerForThisQuestion;
  }
}
